import axios from "axios";
import { toast } from "react-toastify";
import {
  CREATE_HOMEWORK_PERFORMANCE,
  GET_ALL_HOMEWORK_PERFORMANCE,
  GET_STUDENT_HOMEWORK_PERFORMANCE,
  GET_HOMEWORK_PERFORMANCE,
  GET_HOMEWORK_PERFORMANCE_BATCH,
  UPDATE_HOMEWORK_PERFORMANCE,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";

//GET ALL HOMEWORK PERFORMANCE RESULT
export const getAllHomeworkPerformance =
  (batchId, year, month, gradeId, shiftId) => async (dispatch) => {
    const data = {
      batchId,
      year,
      month,
      gradeId,
      shiftId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/homework-performance/all`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_ALL_HOMEWORK_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET HOMEWORK PERFORMANCE RESULT FOR STUDENT INTERVAL
export const getHomeworkPerformanceResult =
  (startMonth, startYear, endMonth, endYear, studentId, year, gradeId, shiftId, batchId) =>
  async (dispatch) => {
    const data = {
      startMonth,
      startYear,
      endMonth,
      endYear,
      year,
      gradeId,
      shiftId,
      batchId,
      studentId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/homework-performance/between`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_HOMEWORK_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET STUDENT LIST FOR HOMEWORK PERFORMANCE (students without entries)
export const getHomeworkPerformanceStudentForBatch =
  (year, month, batchId) => async (dispatch) => {
    const data = {
      year,
      month,
      batchId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/homework-performance/batch`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_STUDENT_HOMEWORK_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET BATCH STUDENTS WITH HOMEWORK PERFORMANCE
export const getBatchHomeworkPerformanceResult =
  (year, month, batchId) => async (dispatch) => {
    const data = {
      year,
      month,
      batchId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/homework-performance/batch-res`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_HOMEWORK_PERFORMANCE_BATCH,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

// CREATE HOMEWORK PERFORMANCE
export const createHomeworkPerformance = (month, year, marks) => async (dispatch) => {
  let data = {
    month: parseInt(month),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `${BASE_URL}/api/homework-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: CREATE_HOMEWORK_PERFORMANCE,
    });
    toast.success("Homework performance added successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// EDIT HOMEWORK PERFORMANCE
export const editHomeworkPerformance = (month, year, marks) => async (dispatch) => {
  let data = {
    month: parseInt(month),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.patch(
      `${BASE_URL}/api/homework-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: UPDATE_HOMEWORK_PERFORMANCE,
    });
    toast.success("Homework performance edited successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};
